import { isActiveChat } from './activeChat';
import { showBrowserNotification } from './browserNotifications';
import { getDefaultDuration } from './notificationTypes';
import { t } from '../i18n';

const APP_LABEL = 'LYNX';

const genericNotification = (message, type = 'info', extra = {}) => ({
  message,
  type,
  browserTitle: APP_LABEL,
  browserBody: message,
  ...extra,
});

const SYSTEM_NOTIFICATIONS = [
  {
    type: 'chat_request',
    getToast: () => genericNotification(t('system.newChatInvite'), 'info'),
  },
  {
    type: 'chat_request_rejected',
    getToast: () => genericNotification(t('system.inviteDeclined'), 'error'),
  },
  {
    type: 'chat_created',
    getToast: (data) => genericNotification(t('system.inviteAccepted'), 'success', {
      navigateChatId: data.data?.chat_id,
    }),
  },
  {
    type: 'chat_restored',
    getToast: (data) => genericNotification(t('system.chatRestored'), 'success', {
      navigateChatId: data.data?.chat_id,
    }),
  },
  {
    type: 'chat_deleted',
    getToast: () => genericNotification(t('system.chatDeleted'), 'warning'),
  },
  {
    type: 'new_chat_message',
    getToast: (data) => {
      const messageChatId = data.data?.chat_id;
      if (!messageChatId || isActiveChat(messageChatId)) {
        return null;
      }
      // Already on the chats workspace — list blink is enough; toast only elsewhere.
      if (typeof window !== 'undefined' && window.location.pathname.startsWith('/chats')) {
        return null;
      }
      return genericNotification(t('system.newMessage'), 'info', {
        navigateChatId: messageChatId,
      });
    },
  },
  {
    type: 'chat_status_changed',
    getToast: (data) => {
      const chatStatus = data.data?.status;
      if (chatStatus !== 'stopped') {
        return null;
      }
      return genericNotification(t('system.chatActivityUpdated'), 'warning', {
        navigateChatId: data.data?.chat_id,
      });
    },
  },
];

export const handleSystemNotification = (data, showNotification) => {
  const config = SYSTEM_NOTIFICATIONS.find((item) => item.type === data.type);
  if (!config) {
    return;
  }

  const toast = config.getToast(data);
  if (!toast) {
    return;
  }

  if (!toast.skipToast && toast.message) {
    showNotification(toast.message, toast.type, getDefaultDuration(toast.type));
  }

  if (document.hidden && toast.browserTitle) {
    showBrowserNotification(
      toast.browserTitle,
      toast.browserBody || toast.message,
      toast.navigateChatId,
    );
  }
};
